class ArtistFeature extends HTMLElement {
  constructor() {
    super();

    this.openButton = this.querySelector("a[href='#artist-popup']");
    this.modalContent = this.querySelector(".popup-content");
    this.closeButton = this.modalContent?.querySelector(".artist-modal-close");

    if (!this.openButton || !this.modalContent) return;

    // Move the modal content to the bottom of <body>
    document.body.appendChild(this.modalContent);
    
    this.openButton.addEventListener("click", (e) => this.openModal(e));
    this.closeButton?.addEventListener("click", () => this.closeModal());
    this.modalContent.addEventListener("click", (e) => {
      if (e.target === this.modalContent) this.closeModal();
    });

    // Hide the modal initially
    this.modalContent.style.display = "none";
  }

  openModal(event) {
    event.preventDefault();
    this.modalContent.style.display = "block"; // Show the modal
    document.body.classList.add("no-scroll");
  }

  closeModal() {
    this.modalContent.style.display = "none"; // Hide the modal
    document.body.classList.remove("no-scroll");
  }
}

customElements.define("artist-feature", ArtistFeature);



document.addEventListener('DOMContentLoaded', function() {
    //HANDHUGS-
    let $availability = document.querySelector('[for="filter-Availability-1"]');
    let isPageload = window.location.search.indexOf('filter.v.availability=') == -1;
    if ($availability && isPageload) { 
      //console.log('testing')
      $availability.click();
      $availability.dispatchEvent(new Event('input', {bubbles: true}));
    } else {
      //console.log('nope')
    }
    
});